import axios from 'axios';
import { API_URL } from '@/config';

export default {

  activity() {
    return axios.get(`${API_URL}/avamar/activity`);
  },

  volumetry() {
    return axios.get(`${API_URL}/avamar/volumetry`);
  },

  exportVolumetry() {
    window.open(`${API_URL}/avamar/export/volumetry?extension=csv`, '_blank');
  },

  total() {
    return axios.get(`${API_URL}/avamar/total`);
  },

  export() {
    window.open(`${API_URL}/avamar/export?extension=csv`, '_blank');
  },

};
